/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewSpiderDataItem
 */
export interface CRSFSecReviewSpiderDataItem {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpiderDataItem
     */
    first_seen: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpiderDataItem
     */
    last_seen: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewSpiderDataItem
     */
    malware_type: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpiderDataItem
     */
    num_ports_affected: number;
}

/**
 * Check if a given object implements the CRSFSecReviewSpiderDataItem interface.
 */
export function instanceOfCRSFSecReviewSpiderDataItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "first_seen" in value;
    isInstance = isInstance && "last_seen" in value;
    isInstance = isInstance && "malware_type" in value;
    isInstance = isInstance && "num_ports_affected" in value;

    return isInstance;
}

export function CRSFSecReviewSpiderDataItemFromJSON(json: any): CRSFSecReviewSpiderDataItem {
    return CRSFSecReviewSpiderDataItemFromJSONTyped(json, false);
}

export function CRSFSecReviewSpiderDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewSpiderDataItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'first_seen': json['first_seen'],
        'last_seen': json['last_seen'],
        'malware_type': json['malware_type'],
        'num_ports_affected': json['num_ports_affected'],
    };
}

export function CRSFSecReviewSpiderDataItemToJSON(value?: CRSFSecReviewSpiderDataItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_seen': value.first_seen,
        'last_seen': value.last_seen,
        'malware_type': value.malware_type,
        'num_ports_affected': value.num_ports_affected,
    };
}

